module.exports = __webpack_public_path__ + "static/media/marvelLogo.44b2fa2f.png";